import React, { useState } from "react";
import { Card, CardBody, Row } from "reactstrap";
import emailImg from "../../assets/images/email.png";

const EmailVerificationCard: React.FC<{
    email: string;
    error?: string;
    notice?: string;
    submitting?: boolean;
    resending?: boolean;
    submitLabel?: string;
    onSubmit: (otp: string) => void;
    onResendOtp: () => void;
}> = ({ email, error, notice, submitting, resending, submitLabel, onSubmit, onResendOtp }) => {
    const [otp, setOtp] = useState("");
    const busy = Boolean(submitting || resending);
    const localDevOtp =
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1");

    return (
        <React.Fragment>
            <div className="payment-card-wrapper">
                <div className="p-3">
                    <Card className="payment-card">
                        <div className="card-header">
                            <Row>
                                <div className="image-container">
                                    <img src={emailImg} className="image" alt="Email Verification" />
                                </div>
                            </Row>
                        </div>
                        <CardBody className="px-5 py-3">
                            <Row className="mb-3 mt-5">
                                <h4 className="text-muted text-center">Verify your email</h4>
                                <p className="text-muted text-center font-size-16">
                                    {email
                                      ? `We sent a 6-digit code to ${email}. It expires in 10 minutes.`
                                      : "Enter the 6-digit code from your email."}
                                </p>
                                {localDevOtp ? (
                                  <p className="text-muted text-center font-size-14 mb-0">
                                    Local only: enter 123456 to continue.
                                  </p>
                                ) : null}
                                {error ? (
                                  <div className="alert alert-danger mt-3 mb-0" role="alert">
                                    {error}
                                  </div>
                                ) : null}
                                {notice ? (
                                  <div className="alert alert-success mt-3 mb-0" role="status">
                                    {notice}
                                  </div>
                                ) : null}
                                <div className="form-group mt-4">
                                    <input
                                        type="text"
                                        name="otp"
                                        id="otp"
                                        className="form-control"
                                        placeholder="Enter the 6-digit code"
                                        value={otp}
                                        inputMode="numeric"
                                        autoComplete="one-time-code"
                                        maxLength={6}
                                        disabled={busy}
                                        onChange={(event) => {
                                          setOtp(event.target.value.replace(/\D/g, "").slice(0, 6));
                                        }}
                                        onKeyDown={(event) => {
                                          if (event.key === "Enter") {
                                            event.preventDefault();
                                            onSubmit(otp);
                                          }
                                        }}
                                    />
                                </div>
                            </Row>
                            <Row className="mb-3">
                                <div className="d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        style={{ backgroundColor: "#34C38F", maxWidth: "50%" }}
                                        disabled={busy}
                                        onClick={() => onSubmit(otp)}
                                    >
                                        {submitting ? "Please wait…" : submitLabel || "Verify Email"}
                                    </button>
                                </div>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
                <label>
                    Didn&apos;t receive an email?{" "}
                    <button
                        type="button"
                        className="btn btn-link p-0"
                        style={{ backgroundColor: "transparent", border: "none", color: "#34C38F", maxWidth: "50%", textDecoration: "none", cursor: "pointer" }}
                        disabled={busy}
                        onClick={() => onResendOtp()}
                    >
                        {resending ? "Sending…" : "Resend"}
                    </button>
                </label>
            </div>
        </React.Fragment>
    );
};

export default EmailVerificationCard;
